import { FilterType } from "@/shared/enums/Filter.enum";
import { Column, FilterConfig } from "@/shared/types";

const allUsersFilters: FilterConfig[] = [
	{
		id: "name",
		name: "Name",
		description: "Filter by Name",
		placeholder: "enter_name",
		items: [],
		type: FilterType.INPUT,
	},
	{
		id: "status",
		name: "Status",
		description: "Filter by Status",
		items: [
			{ id: "company_pending", label: "company_pending" },
			{ id: "company_rejected", label: "company_rejected" },
			{ id: "not_started", label: "not_started" },
			{ id: "not_reached", label: "not_reached" },
			{ id: "active", label: "active" },
			{ id: "end_user_quit", label: "end_user_quit" },
			{ id: "company_ended", label: "company_ended" },
			{ id: "paused", label: "paused" },
			{ id: "delivery_completed", label: "delivery_completed" },
		],
	},
];

const openDhcFilters: FilterConfig[] = [
	{
		id: "name",
		name: "Name",
		description: "Filter by Name",
		placeholder: "enter_name",
		items: [],
		type: FilterType.INPUT,
	},
	{
		id: "status",
		name: "Status",
		description: "Filter by Status",
		items: [
			{ id: "company_pending", label: "company_pending" },
			{ id: "company_rejected", label: "company_rejected" },
			{ id: "company_approved", label: "company_approved" },
			{ id: "not_started", label: "not_started" },
			{ id: "not_reached", label: "not_reached" },
			{ id: "active", label: "active" },
			{ id: "end_user_quit", label: "end_user_quit" },
			{ id: "company_ended", label: "company_ended" },
			{ id: "paused", label: "paused" },
			{ id: "delivery_completed", label: "delivery_completed" },
		],
	},
];

const availableColumns: Column[] = [
	{ field: "name", label: "Name" },
	{ field: "status", label: "Status" },
	{ field: "dhc", label: "DHC" },
	{ field: "phone", label: "Phone" },
	{ field: "startDate", label: "Start date" },
	{ field: "active", label: "Active" },
	{ field: "product", label: "Product" },
	{ field: "swapReq", label: "Swap Req" },
	{ field: "company", label: "Company" },
];

const endUserColumns: string[] = [
	"name",
	"status",
	"dhc",
	"phone",
	"startDate",
	"active",
	"product",
	"swapReq",
	"company",
];

export { allUsersFilters, openDhcFilters, availableColumns, endUserColumns };
